const root = {
  accessDenied: 'Access Denied',
  wrongPermissionsDesc: 'Oops! You don’t have permission to access the requested page. If you think you should have access, please contact your administrator.',
};
export default root;
